import { memo, useCallback } from 'react';
import { useQuery } from 'convex/react';
import { api } from '../../../convex/_generated/api';
import { Button } from '@/components/ui/button';
import { IConnectAccountButtonProps } from '@/@types/socialMedia';

/**
 * Button to initiate Facebook Page OAuth connection
 */
const ConnectAccountButton = ({
  platform,
  disabled = false,
  className,
}: IConnectAccountButtonProps) => {
  const userId = useQuery(api.users.getCurrentUserId);

  const handleConnect = useCallback(() => {
    if (!userId) {
      return;
    }

    // Redirect to OAuth authorize endpoint
    // HTTP actions are served at .convex.site, not .convex.cloud
    const convexUrl = import.meta.env.VITE_CONVEX_URL;
    // Convert https://xyz.convex.cloud to https://xyz.convex.site
    const siteUrl = convexUrl.replace('.convex.cloud', '.convex.site');

    // Pass frontend URL so OAuth callback can redirect back here
    const frontendUrl = window.location.origin;
    const authorizeUrl = `${siteUrl}/oauth/facebook/authorize?userId=${userId}&returnUrl=${encodeURIComponent(frontendUrl)}`;

    window.location.href = authorizeUrl;
  }, [userId]);

  const buttonText = platform === 'facebook_page' ? 'Connect Facebook Page' : 'Connect Account';
  const isLoading = userId === undefined;
  const isDisabled = disabled || isLoading || !userId;

  return (
    <Button onClick={handleConnect} disabled={isDisabled} className={className}>
      {isLoading ? 'Loading...' : buttonText}
    </Button>
  );
};

export const ConnectAccountButtonMemo = memo(ConnectAccountButton);
